import axios from "axios";
import { API_BASE_URL, extractErrorMessage } from "../../api";

const token = () => sessionStorage.getItem("token");

const authHeaders = (extra = {}) => ({
    Authorization: `Bearer ${token()}`,
    uid: sessionStorage.getItem("uid"),
    "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
    ...extra,
});

const toIsoDate = (value) => {
    if (!value) return null;
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString().slice(0, 10);
};

export const buildSplitPayload = ({ campagneId, formationId, criteria, personnesParGroupe, dateDebut, dateFin, populationFilter }) => ({
    campagneId,
    formationId,
    criteria,
    personnesParGroupe,
    dateDebut: toIsoDate(dateDebut),
    dateFin: toIsoDate(dateFin),
    populationFilter: populationFilter || null,
});

export async function fetchConsolidationSplitFormations({ campagneId, dateDebut, dateFin }) {
    const params = new URLSearchParams();
    const from = toIsoDate(dateDebut);
    const to = toIsoDate(dateFin);
    if (from) params.set("dateDebut", from);
    if (to) params.set("dateFin", to);

    const suffix = params.toString() ? `?${params.toString()}` : "";
    const response = await axios.get(
        `${API_BASE_URL}/api/consolidation/campagnes/${campagneId}/formations${suffix}`,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function previewConsolidationSplit(payload) {
    const response = await axios.post(
        `${API_BASE_URL}/api/consolidation/split/preview`,
        payload,
        { headers: authHeaders({ "Content-Type": "application/json" }) }
    );
    return response.data;
}

export async function exportConsolidationSplit(payload) {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/consolidation/split/export`,
            payload,
            {
                headers: authHeaders({ "Content-Type": "application/json" }),
                responseType: "blob",
            }
        );
        return response;
    } catch (error) {
        const fallback = "Erreur lors de l'export du bilan split.";
        if (error?.response?.data instanceof Blob) {
            const text = await error.response.data.text();
            try {
                const parsed = JSON.parse(text);
                throw new Error(parsed?.message || parsed?.error || fallback);
            } catch {
                throw new Error(text || fallback);
            }
        }
        throw new Error(extractErrorMessage(error, fallback));
    }
}
